import { render } from "./PtResourceDetail.vue?vue&type=template&id=473823f0&scoped=true"
import script from "./PtResourceDetail.vue?vue&type=script&lang=js"
export * from "./PtResourceDetail.vue?vue&type=script&lang=js"

import "./PtResourceDetail.vue?vue&type=style&index=0&id=473823f0&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473823f0"]])

export default __exports__